export default __webpack_public_path__ + "static/media/NEAS0600.34I-38119_-22432_0.032cab60.jpg";